import { makeStyles } from "@material-ui/core/styles";
import {
  MODUS_FIELD_BG_DISABLED,
  MODUS_FIELD_BORDER_ENABLED,
  MODUS_FIELD_BORDER_ERROR,
  MODUS_FIELD_TEXT_DISABLED,
} from "../field-common/formFieldTokens";

export const useTextAreaStyles = makeStyles(() => ({
  root: {
    width: "100%",
    margin: "7px 0",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  labelGroup: {
    display: "flex",
    alignItems: "baseline",
    flexWrap: "wrap",
    gap: 0,
  },
  label: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 600,
    color: "#0e2c37",
  },
  labelHint: {
    fontSize: "14px",
    lineHeight: "20px",
    marginLeft: "2px",
    fontWeight: 400,
    color: "#6A6E79",
  },
  labelDisabled: {
    fontWeight: 700,
    color: "#595959",
  },
  labelHintDisabled: {
    fontWeight: 400,
    color: "#808080",
  },
  charCount: {
    fontSize: "12px",
    lineHeight: "18px",
    color: "#6A6E79",
    flexShrink: 0,
    marginLeft: "8px",
  },
  charCountDisabled: {
    color: "#b3b6bc",
  },
  /** Enabled: single #171C1E border */
  fieldShell: {
    borderRadius: "4px",
    border: `1px solid ${MODUS_FIELD_BORDER_ENABLED}`,
    backgroundColor: "#FFFFFF",
    boxShadow: "none",
    outline: "none",
    transition: "border-color 0.15s ease",
  },
  fieldShellError: {
    borderColor: MODUS_FIELD_BORDER_ERROR,
  },
  /** Disabled: no border, same fill as TextField */
  fieldShellDisabled: {
    backgroundColor: MODUS_FIELD_BG_DISABLED,
    border: "none",
    boxShadow: "none",
    "&:focus-within": {
      boxShadow: "none",
    },
  },
  textarea: {
    display: "block",
    width: "100%",
    margin: 0,
    padding: "14px 16px",
    fontFamily: "inherit",
    fontSize: "14px",
    lineHeight: "22px",
    color: "#171C1E",
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    resize: "vertical",
    minHeight: "91px",
    boxSizing: "border-box",
    borderRadius: "4px",
  },
  textareaDisabled: {
    color: MODUS_FIELD_TEXT_DISABLED,
    cursor: "default",
    resize: "none",
    opacity: 1,
    WebkitTextFillColor: MODUS_FIELD_TEXT_DISABLED,
  },
  helper: {
    marginTop: "4px",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#AB1F26",
  },
}));
